<template>
    <div>
        <div class="flex">
            <div class="w-3/4 bg-pink-100">
                <Welcome v-if="currentPage === 'welcome'"/>
                <Page1 v-if="currentPage === 'page1'"/>
                <Page2 v-if="currentPage === 'page2'"/>
                <div class="flex justify-center">
                    <div class="flex justify-center p-4 w-40" style="background-color: antiquewhite;">
                        <button @click="pageOneMethod" class="bg-gray-500 rounded-50p w-3 h-3 mr-2"></button>
                        <button @click="pageTwoMethod" class="bg-gray-500 rounded-50p w-3 h-3 mr-2"></button>
                        <button @click="pageThreeMethod" class="bg-gray-500 rounded-50p w-3 h-3 mr-2"></button>
                        <button class="bg-gray-500 rounded-50p w-3 h-3 mr-2"></button>
                        <button class="bg-gray-500 rounded-50p w-3 h-3 mr-2"></button>
                        <button class="bg-gray-500 rounded-50p w-3 h-3 mr-2"></button>
                    </div>
                </div>
            </div>
            <div class="w-1/4">
                <div class="mt-32 ml-8">
                    <div class="flex">
                        <div ref="firstHHthree" @click="pageOneMethod" :class="{onboardingSideDiv:true,borderColor1: page1, borderColor:page11}">
                            <h3 ref="firstHthree">1</h3>
                        </div>
                        <div @click="pageOneMethod" class="ml-2 cursor-pointer">
                            <h3 class="font-bold">Setup available rooms</h3>
                            <h3 class="opacity-50">Choose your system</h3>
                        </div>
                    </div>
                    <div :class="{borderColor: page2, verticalLine: true}"></div>
                    <div class="flex mt-1">
                        <div ref="secondHHthree" @click="pageTwoMethod" :class="{onboardingSideDiv:true, borderColor:page2}">
                            <h3 class="fontColor" ref="secondHthree">2</h3>
                        </div>
                        <div @click="pageTwoMethod" class="ml-2 cursor-pointer">
                            <h3 class="font-bold">Provide teacher details</h3>
                            <h3 class="opacity-50">Choose your system</h3>
                        </div>
                    </div>
                    <div :class="{borderColor: page3, verticalLine: true}"></div>
                    <div class="flex mt-1">
                        <div ref="thirdHHthree" @click="pageThreeMethod" :class="{onboardingSideDiv:true, borderColor:page3}">
                            <h3 class="fontColor" ref="thirdHthree">3</h3>
                        </div>
                        <div @click="pageThreeMethod" class="ml-2 cursor-pointer">
                            <h3 class="font-bold">Setup Core PE Assessment</h3>
                            <h3 class="opacity-50">Choose your system</h3>
                        </div>
                    </div>
                    <div :class="{borderColor: false, verticalLine: true}"></div>
                    <div class="flex mt-1">
                        <div :class="{onboardingSideDiv:true, borderColor:false}">
                            <h3 class="fontColor" ref="fourthHthree">4</h3>
                        </div>
                        <div class="ml-2 cursor-pointer">
                            <h3 class="font-bold">Tell us your exam board</h3>
                            <h3 class="opacity-50">Choose your system</h3>
                        </div>
                    </div>
                    <div :class="{borderColor: false, verticalLine: true}"></div>
                    <div class="flex mt-1">
                        <div :class="{onboardingSideDiv:true, borderColor:false}">
                            <h3 class="fontColor" ref="fifthHthree">5</h3>
                        </div>
                        <div class="ml-2 cursor-pointer">
                            <h3 class="font-bold">Upload your pupil list</h3>
                            <h3 class="opacity-50">Choose your system</h3>
                        </div>
                    </div>
                </div>
                <div class="mt-40 ml-8">
                    <i class="fas mr-2 fa-times-circle"></i>
                    <h3 class="font-bold">Having trouble?</h3>
                    <p class="opacity-50">Feel free to contact us and we will always help you through the process</p>
                    <button class="border-2 p-2 mt-4 border-pink-100">Contact us</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Welcome from "@/components/onboarding/Welcome.vue";
import Page1 from "@/components/onboarding/Page1.vue";
import Page2 from "@/components/onboarding/Page2.vue";
export default{
        name: "Onboarding",
        components: {
            Welcome,
            Page1,
            Page2
        },
        data(){
            return {
                currentPage: "welcome",
                page1: true,
                page2: false,
                page3: false
            }
        },
        methods: {
            pageOneMethod(){
                this.currentPage = 'welcome';
                this.page2 = false;
                this.page3 = false;
                this.page1 = false;
                this.page11 = true;
                this.$refs.firstHthree.textContent = "1";
                this.$refs.firstHHthree.style.backgroundColor = "white";
                this.$refs.firstHHthree.style.borderColor = "#1F5BD2";
                this.$refs.firstHthree.style.color = "#1F5BD2";
                this.$refs.secondHthree.textContent = "2";
                this.$refs.secondHHthree.style.borderColor = "#E2E8F0";
                this.$refs.secondHHthree.style.backgroundColor = "white";
                this.$refs.secondHthree.style.color = "#E2E8F0";
                this.$refs.thirdHthree.textContent = "3";
                this.$refs.thirdHHthree.style.borderColor = "#E2E8F0";
                this.$refs.thirdHthree.style.color = "#E2E8F0";
            },
            pageTwoMethod(){
                this.currentPage = 'page1';
                this.page2 = true;
                this.page3 = false;
                this.page1 = true;
                this.$refs.firstHthree.textContent = "✔";
                this.$refs.firstHHthree.style.backgroundColor = "#12B76A";
                this.$refs.firstHHthree.style.borderColor = "#12B76A";
                this.$refs.firstHthree.style.color = "white";
                this.$refs.secondHthree.textContent = "2";
                this.$refs.secondHHthree.style.borderColor = "#1F5BD2";
                this.$refs.secondHHthree.style.backgroundColor = "white";
                this.$refs.secondHthree.style.color = "#1F5BD2";
                this.$refs.thirdHthree.textContent = "3";
                this.$refs.thirdHHthree.style.borderColor = "#E2E8F0";
                this.$refs.thirdHthree.style.color = "#E2E8F0";
            },
            pageThreeMethod(){
                this.currentPage = 'page2';
                this.page2 = true;
                this.page3 = true;
                this.page1 = true;
                this.$refs.firstHthree.textContent = '✔';
                this.$refs.firstHHthree.style.backgroundColor = "#12B76A";
                this.$refs.firstHHthree.style.borderColor = "#12B76A";
                this.$refs.firstHthree.style.color = "white";
                this.$refs.secondHthree.textContent = '✔';
                this.$refs.secondHHthree.style.backgroundColor = "#12B76A";
                this.$refs.secondHHthree.style.borderColor = "#12B76A";
                this.$refs.secondHthree.style.color = "white";
                this.$refs.thirdHthree.textContent = "3";
                this.$refs.thirdHHthree.style.borderColor = "#1F5BD2";
                this.$refs.thirdHthree.style.color = "#1F5BD2";
            }
        }
}
</script>

<style scoped>
.onboardingSideDiv{
    border-radius: 50%;
    border-width: 1px;
    width:1.5rem;
    height: 1.5rem;
    display:flex;
    justify-content: center;
    flex-wrap: wrap;
    align-content: center;
    cursor:pointer;
}
.borderColor{
    border-color: #12B76A;
}
.borderColor1{
    border-color: #1F5BD2;
}
.verticalLine{
    border-width: 1px; 
    height: 2rem; 
    width: 1px; 
    margin-left: 0.7rem; 
    margin-top: -1rem;
}
.fontColor{
    color:#E2E8F0;
}
</style>